import type { MailOutboxItem } from "@/lib/notification.api";
import { cn } from "@/lib/utils";
import {
  formatNotificationDateTime,
  getMailOutboxStatusLabel,
  getMailOutboxStatusTone,
} from "../notification.formatters";

export function MailOutboxPreviewRow({
  item,
}: {
  item: Pick<
    MailOutboxItem,
    "recipient" | "subject" | "templateKey" | "status" | "createdAt" | "errorMessage"
  >;
}) {
  const tone = getMailOutboxStatusTone(item.status);
  const label = getMailOutboxStatusLabel(item.status);

  return (
    <div className="grid gap-2 px-4 py-3 sm:grid-cols-[minmax(0,1fr)_auto] sm:items-start">
      <div className="min-w-0">
        <div className="flex min-w-0 flex-wrap items-center gap-2">
          <p className="truncate text-[12px] font-semibold text-foreground">{item.subject}</p>
          <span className={cn("rounded border px-2 py-0.5 text-[10.5px] font-semibold", tone)}>
            {label}
          </span>
        </div>
        <p className="mt-1 truncate text-[11px] text-muted-foreground">
          {item.recipient} - {item.templateKey}
        </p>
        {item.errorMessage && (
          <p className="mt-1 truncate text-[11px] text-danger-text">{item.errorMessage}</p>
        )}
      </div>
      <p className="text-[10.5px] text-subtle">{formatNotificationDateTime(item.createdAt)}</p>
    </div>
  );
}
